// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IUpdateContactPreferencesResultModel } from './iUpdateContactPreferencesResultModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class AccountAccountUpdateContactPreferencesDefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': IUpdateContactPreferencesResultModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof AccountAccountUpdateContactPreferencesDefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "IUpdateContactPreferencesResultModel"
        },
    ];

    static getAttributeTypeMap() {
        return AccountAccountUpdateContactPreferencesDefaultResponse.attributeTypeMap;
    }
}
